export default "__VITE_ASSET__DOXSgfEX__"